import { FieldBlock } from '@coast/schemas';
import { isNil } from 'lodash';
import React from 'react';
import { MBFieldBlock } from '../field';

interface Props {
  block: FieldBlock;
  value: any;
}
export function SubformsFieldBlock({ block, value }: Props) {
  if (isNil(value)) {
    return null;
  }
  return <MBFieldBlock value={value.name} block={block} />;
}
